@import '../../../constants/spacing.module.less';

.modal-body {
  padding: @space-24;
}

.terms-link {
  color: var(--blue-006FBB);
  text-decoration: underline;
}

.external-link-icon {
  width: 12px;
  margin-left: @space-4;
}
